<template>
    <v-dialog-old
        ref="exportBitrixDialog"
        class="glue"
        :special-styles="{ width: '1800px' }"
    >
        <fieldset>
            <legend>
                <span>Bitrix Export</span>
            </legend>
            <div>
                <footer>
                    <button @click="exportBitrix()" disabled>
                        Все
                    </button>

                    <div class="links">
                        <i v-if="fileExist" class="far fa-file-excel fa-lg"  @click.stop.prevent="getExportBitrixAllFile()"/>
                    </div>

                    <br><hr>
                    <button
                        v-for="city in cityOptions"
                        @click="exportBitrix(city)"
                        style="margin: 10px"
                    >{{ city.text }}
                    </button>
                    <br><hr>
                    <button @click="closeModal" style="color:red">
                        Отмена
                    </button>
                </footer>
            </div>
        </fieldset>
    </v-dialog-old>
</template>

<script>
    export default {
        props: {
            cityOptions: {
                required: true,
                type: Array,
            },
        },
        data:function (){
            return {
                fileExist:false,
            }
        },
        methods: {
            show() {
                this.$refs.exportBitrixDialog.show();
                this.axios.get('tools/bitrixExportDialogData', {}).then(response => {
                    this.fileExist = response.data.file
                });
            },
            getExportBitrixAllFile(){
                document.location = 'tools/bitrixClinicExportAllGetFile'
            },
            closeModal() {
                this.$refs.exportBitrixDialog.hide();
                this.fileExist = false
            },
            exportBitrix(city) {
                if (city) {
                    document.location = 'tools/bitrixClinicExport?city=' + city.value;
                } else {
                    this.axios.get('tools/bitrixClinicExportAll')
                }
            }
        },
    }
</script>

